import { render, staticRenderFns } from "./ReopenInvoice.vue?vue&type=template&id=31954303&"
import script from "./ReopenInvoice.vue?vue&type=script&lang=js&"
export * from "./ReopenInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports